// extracted by mini-css-extract-plugin
export default {"formContainer":"ScanOrEnterBarcodeForm_formContainer__+SSJS"};